var render = function render(){var _vm=this,_c=_vm._self._c;return _c('display-control',{attrs:{"data-aid":_vm.actor.id,"component":_vm.actor.component,"name":(_vm.currentSnapshot.rev === 2 ? _vm.actor.title : _vm.actor.name),"description":_vm.actor.description,"status-var":_vm.getStatusVarByControlActor(_vm.actor),"vars":_vm.getActorVars(_vm.actor),"show-label":_vm.showLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }